import { CommonModule } from '@angular/common'
import { Component, ElementRef, HostListener } from '@angular/core'
import { AccountService } from '@core/services'
import { RushMainService } from '@rush-shared/services'
import { DockTabsConst } from '@rush-shared/constants'
import { TabModel } from '@rush-shared/models'

@Component({
  selector: 'app-rush-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rush-profile.component.html',
  styleUrl: './rush-profile.component.sass',
})
export class RushProfileComponent {
  profilePicture?: string
  accountName?: string
  isSmallScreen: boolean
  openProfileMenu = false

  isDropdownOpen = false

  dockTabs = DockTabsConst

  get chips(): number {
    return this._accountService.userInitData?.chips || 0
  }

  get isPlayer(): boolean {
    return this._accountService.isPlayer
  }
  get isLogger(): boolean {
    return this._accountService.isLogger
  }
  get initial(): string {
    return this._accountService.userInitData?.initialName || ''
  }

  constructor(
    private _accountService: AccountService,
    public _rushMainService: RushMainService,
    private eRef: ElementRef,
  ) {
    this.isSmallScreen = window.innerWidth <= 768
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isSmallScreen = window.innerWidth <= 768
  }

  get shouldHide(): boolean {
    return this.isLogger && this.isSmallScreen
  }

  ngOnInit(): void {
    this._accountService.$userInitData.subscribe((i) => {
      this.profilePicture = i?.profilePicture
      this.accountName = i?.accountName
    })
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen
  }

  onTabSelected(tab: TabModel) {
    this._rushMainService.setActiveTab(tab)
  }

  logout() {
    this._accountService.logout()
  }
  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.openProfileMenu = false
    }
  }
}
